import * as React from "react";
function SvgCircleUser(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <circle cx={16} cy={16} r={15} />
        <circle cx={16} cy={12.77} r={3.77} />
        <path d="M13.37 23h-3.29a5.92 5.92 0 0111.85 0h-3.3" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCircleUser);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
